<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col>Grupos</v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="add()">
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="groups"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template slot="no-data">
            <span> Nenhum Grupo encontrado </span>
          </template>

          <template v-slot:header.visualizaMunicipio="{ header }">
            <span>
              {{ header.text }}
              <AppYesOrNOCombobox
                :editValue="all"
                :value="'visualizaMunicipio'"
                @onChange="
                  groups = groups.map((item) => {
                    return {
                      ...item,
                      visualizaMunicipio: all.visualizaMunicipio,
                    };
                  })
                "
              ></AppYesOrNOCombobox>
            </span>
          </template>

          <template v-slot:header.desabilitar="{ header }">
            <span>
              {{ header.text }}
              <AppYesOrNOCombobox
                :editValue="all"
                :value="'desabilitar'"
                @onChange="
                  groups = groups.map((item) => {
                    return {
                      ...item,
                      desabilitar: all.desabilitar,
                    };
                  })
                "
              ></AppYesOrNOCombobox>
            </span>
          </template>
          <template v-slot:header.verSomenteSeuNome="{ header }">
            <span>
              {{ header.text }}
              <AppYesOrNOCombobox
                :editValue="all"
                :value="'verSomenteSeuNome'"
                @onChange="
                  groups = groups.map((item) => {
                    return {
                      ...item,
                      verSomenteSeuNome: all.verSomenteSeuNome,
                    };
                  })
                "
              ></AppYesOrNOCombobox>
            </span>
          </template>

          <template v-slot:header.verTodosEixos="{ header }">
            <span>
              {{ header.text }}
              <AppYesOrNOCombobox
                :editValue="all"
                :value="'verTodosEixos'"
                @onChange="
                  groups = groups.map((item) => {
                    return {
                      ...item,
                      verTodosEixos: all.verTodosEixos,
                    };
                  })
                "
              ></AppYesOrNOCombobox>
            </span>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.nome }}
              </td>

              <td>
                <AppYesOrNOCombobox
                  :editValue="item"
                  :value="'visualizaMunicipio'"
                ></AppYesOrNOCombobox>
              </td>
              <td>
                <AppYesOrNOCombobox
                  :editValue="item"
                  :value="'verTodosEixos'"
                ></AppYesOrNOCombobox>
              </td>
              <td>
                <AppYesOrNOCombobox
                  :editValue="item"
                  :value="'verSomenteSeuNome'"
                ></AppYesOrNOCombobox>
              </td>

              <td>
                <AppYesOrNOCombobox
                  :editValue="item"
                  :value="'desabilitar'"
                ></AppYesOrNOCombobox>
              </td>

              <td>
                <groups-combo :filter="item"></groups-combo>
              </td>

              <td>
                <relatorios-combo :filter="item"></relatorios-combo>
              </td>

              <td>
                <div class="acoes">
                  <ModalDeleteGroup
                    :payload="item"
                    @onDelete="load()"
                  ></ModalDeleteGroup>

                  <div class="edit" @click="edit(item.usuarioGrupoId)">
                    <v-icon style="color: green">mdi-pencil</v-icon>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row
      ><v-col class="buttonactions">
        <v-btn color="primary" @click="saveGroup()">Salvar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppYesOrNOCombobox from "./Combobox";
import ModalDeleteGroup from "./ModalDelete.vue";

import { groupsAPI } from "../API/groupsAPI";

import GroupsCombo from "./GroupsCombo";
import RelatoriosCombo from "./RelatoriosCombo";
import { relatorios } from "@/modules/administrative-dashboard/utils/relatorio";

export default {
  components: {
    AppYesOrNOCombobox,
    ModalDeleteGroup,
    RelatoriosCombo,
    GroupsCombo,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        {
          text: "Ver todos os municípios",
          value: "visualizaMunicipio",
          sortable: false,
        },
        { text: "Ver todos os eixos", value: "verTodosEixos", sortable: false },
        {
          text: "Ver somente seu nome",
          value: "verSomenteSeuNome",
          sortable: false,
        },
        { text: "Desabilitar", value: "desabilitar", sortable: false },
        {
          text: "Hierarquia",
          value: "hierarquia",
          sortable: false,
          width: "20%",
        },
        {
          text: "Relatórios Adm",
          value: "relatoriosAdm",
          sortable: false,
          width: "20%",
        },
        { text: "Ações", value: "acoes", width: "20%", sortable: false },
      ],
      groups: [],
      hierarquiaIds: [],
      all: {
        visualizaMunicipio: false,
        desabilitar: false,
        verEixos: false,
        verSomenteSeuNome: false,
      },
      search: "",
    };
  },

  methods: {
    ...mapActions(["setLoading", "renewUser"]),
    load() {
      this.setLoading(true);
      groupsAPI.get().then(({ data }) => {
        this.groups = data.map((item) => {
          return {
            ...item,
            hierarquia: item.hierarquia && JSON.parse(item.hierarquia),
            relatorioAdm: item.relatorioAdm && JSON.parse(item.relatorioAdm),
          };
        });

        this.setLoading(false);
      });
    },
    add() {
      this.$router.push("/groups/add");
    },
    edit(id) {
      this.$router.push(`/groups/edit/${id}`);
    },
    saveGroup() {
      this.groups = this.groups.map((item) => {
        return {
          ...item,
          hierarquia: item.hierarquia && JSON.stringify(item.hierarquia),
          relatorioAdm: item.relatorioAdm
            ? JSON.stringify(item.relatorioAdm)
            : JSON.stringify(relatorios.map((item) => item.id)),
        };
      });

      this.setLoading(true);
      groupsAPI
        .updateMultiple(this.groups)
        .then(() => {
          this.$notification.success("Grupos salvos com sucesso");
          this.renewUser();

          this.load();
        })
        .catch((err) => {
          this.setLoading(false);
          console.log("err: ", err);
          this.$notification.error("Erro ao salvar grupo");
        });
    },
  },

  mounted() {
    this.load();

    if (this.isGov) {
      this.headers = [
        { text: "Nome", value: "nome" },
        {
          text: "Ver todos os projetos",
          value: "visualizaMunicipio",
          sortable: false,
        },
        { text: "Ver todos os eixos", value: "verTodosEixos", sortable: false },
        {
          text: "Ver somente seu nome",
          value: "verSomenteSeuNome",
          sortable: false,
        },
        { text: "Desabilitar", value: "desabilitar", sortable: false },
        {
          text: "Hierarquia",
          value: "hierarquia",
          sortable: false,
          width: "20%",
        },
        {
          text: "Relatórios Adm",
          value: "relatoriosAdm",
          sortable: false,
          width: "20%",
        },
        { text: "Ações", value: "acoes", width: "20%", sortable: false },
      ];
    }
  },

  computed: {
    ...mapGetters(["isFullAdmin", "config", "isGov"]),
  },
};
</script>
<style>
th {
  min-height: 80px;
}
</style>
<style scoped lang="scss">
.acoes {
  display: flex;
}
.edit {
  border: 1px solid green;
  padding: 0 16px;
  height: 36px;
  display: flex;
  border-radius: 5px;
  cursor: pointer;
}

.buttonactions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 2rem;
  margin-right: 12px;
}
</style>
